import { Form } from "react-bootstrap";
import type { ProjectDepartmentDto as DepartmentDto } from "../../../api/generated/model";
import { Department } from "../../../api/generated/model";

type DropDownSelectDepartmentProps = {
  departments?: DepartmentDto[];
  selectedDepartment?: number;
  setSelectedDepartment: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
};

const DropDownSelectDepartment: React.FC<DropDownSelectDepartmentProps> = (
  props
) => {
  const handleChange = (value: number) => {
    props.setSelectedDepartment(value);
  };

  const filteredDepartments = props.departments
    ? props.departments.filter((department) => [
        Department.Building, // Building
        Department.Scaffolding, // Scaffolding
        Department.WeatherProtection, // WeatherProtection
        Department.Elevator, // Elevator
      ].includes(department.avd as Department))
    : [];

  return (
    <Form>
      <Form.Label>Avdelning</Form.Label>
      <Form.Select
        value={props.selectedDepartment ?? undefined}
        onChange={(e) => handleChange(parseInt(e.target.value))}
        disabled={!filteredDepartments || filteredDepartments.length === 0}
      >
        <option value={-1}>---Välj avdelning---</option>
        {filteredDepartments.map((item) => (
          <option key={item.avd} value={item.avd ?? undefined}>
            {item.avd}. {item.namn}
          </option>
        ))}
      </Form.Select>
    </Form>
  );
};

export default DropDownSelectDepartment;